export default "__VITE_ASSET__osavXT_u__"